import { createAction, createAsyncAction } from 'typesafe-actions'
import VinRequestData from '../../../entities/VinRequestData'
import VinStatus from '../../../entities/VinStatus'
import { VinDataStatusState } from '../../reducers/vinStatusDataReducer'

export const loadConfigurationByVin = createAction('CMD / VinRequestData / get configuration by vin')<VinRequestData>()

export const loadConfigurationByVinAsync = createAsyncAction(
    'EVT / VinData / get configuration by vin request',
    'EVT / VinData / get configuration by vin success',
    'EVT / VinData / get configuration by vin failure',
)<VinRequestData, VinStatus, Error>()

export const setVinDataStatusState = createAction('DOC / VinDataStatusState / set vin state')<VinDataStatusState>()
export const resetVinDataStatusState = createAction('DOC / VinDataStatusState / reset state')()
export const resetVinData = createAction('CMD / Reset / reset vin data')()
